// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-info[data-v-c44eccc8]{display:flex;justify-content:space-between;color:#fff;font-size:16px;text-align:center;margin-bottom:40px;padding:10px;background-color:#24cf94}.header-info .icon-close[data-v-c44eccc8]{font-size:10px;margin-left:1rem;align-self:center;cursor:pointer}.header-info a[data-v-c44eccc8]{font-weight:700;text-decoration:none}.header-info a[data-v-c44eccc8]:hover{text-decoration:underline}.link[data-v-c44eccc8]{color:#443fdb}", ""]);
// Exports
module.exports = exports;
